import { createFileRoute } from '@tanstack/react-router'
import { NotFoundPage } from 'pages/not-found/NotFoundPage'

export const Route = createFileRoute('/_/not-found')({
  component: NotFoundPage,
})
